import { render } from "./createsalesreturns.vue?vue&type=template&id=7fa09413"
import script from "./createsalesreturns.vue?vue&type=script&lang=js"
export * from "./createsalesreturns.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__